/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      status
      athleteId
      judgeType
      judgeTypeProxy
      createdAt
      updatedAt
      name
      firstName
      lastName
      location
      handle
      colors
      profileImg
      googleId
      facebookId
      appleId
      cognitoId
      _version
      _deleted
      _lastChangedAt
      owner
      coach {
        nextToken
        startedAt
        __typename
      }
      judgeSessions {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        status
        athleteId
        judgeType
        judgeTypeProxy
        createdAt
        updatedAt
        name
        firstName
        lastName
        location
        handle
        colors
        profileImg
        googleId
        facebookId
        appleId
        cognitoId
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const UserByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        status
        athleteId
        judgeType
        judgeTypeProxy
        createdAt
        updatedAt
        name
        firstName
        lastName
        location
        handle
        colors
        profileImg
        googleId
        facebookId
        appleId
        cognitoId
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        email
        status
        athleteId
        judgeType
        judgeTypeProxy
        createdAt
        updatedAt
        name
        firstName
        lastName
        location
        handle
        colors
        profileImg
        googleId
        facebookId
        appleId
        cognitoId
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const syncUsers = /* GraphQL */ `
  query SyncUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        email
        status
        athleteId
        judgeType
        judgeTypeProxy
        createdAt
        updatedAt
        name
        firstName
        lastName
        location
        handle
        colors
        profileImg
        googleId
        facebookId
        appleId
        cognitoId
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const SessionsByHost = /* GraphQL */ `
  query SessionsByHost(
    $hostId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SessionsByHost(
      hostId: $hostId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const SessionByKey = /* GraphQL */ `
  query SessionByKey(
    $sessionKey: String
    $sortDirection: ModelSortDirection
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SessionByKey(
      sessionKey: $sessionKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const searchSessions = /* GraphQL */ `
  query SearchSessions(
    $filter: SearchableSessionFilterInput
    $sort: SearchableSessionSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchSessions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const syncSessions = /* GraphQL */ `
  query SyncSessions(
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSessions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSession = /* GraphQL */ `
  query GetSession($id: ID!) {
    getSession(id: $id) {
      id
      sessionKey
      name
      type
      gender
      judging
      judgingRequired
      competition
      apparatus
      access
      startAt
      endAt
      status
      teamScoring
      alternating
      judgePanel
      createdAt
      updatedAt
      admins
      producers
      coaches
      judges
      producer
      featureFlags
      rtnId
      hostId
      hostType
      location
      attendance
      _version
      _deleted
      _lastChangedAt
      owner
      rotations {
        nextToken
        startedAt
        __typename
      }
      squads {
        nextToken
        startedAt
        __typename
      }
      judgeAssignments {
        nextToken
        startedAt
        __typename
      }
      sessionJudges {
        nextToken
        startedAt
        __typename
      }
      sessionTeams {
        nextToken
        startedAt
        __typename
      }
      rosters {
        nextToken
        startedAt
        __typename
      }
      lineups {
        nextToken
        startedAt
        __typename
      }
      streams {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listSessions = /* GraphQL */ `
  query ListSessions(
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getRotation = /* GraphQL */ `
  query GetRotation($id: ID!) {
    getRotation(id: $id) {
      id
      sessionId
      order
      status
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      stages {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listRotations = /* GraphQL */ `
  query ListRotations(
    $filter: ModelRotationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRotations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        order
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const SessionRotations = /* GraphQL */ `
  query SessionRotations(
    $sessionId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelRotationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SessionRotations(
      sessionId: $sessionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionId
        order
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRotations = /* GraphQL */ `
  query SyncRotations(
    $filter: ModelRotationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRotations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        order
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStage = /* GraphQL */ `
  query GetStage($id: ID!) {
    getStage(id: $id) {
      id
      sessionId
      rotationId
      status
      apparatus
      squadId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      rotation {
        id
        sessionId
        order
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      owner
      streams {
        nextToken
        startedAt
        __typename
      }
      judges {
        nextToken
        startedAt
        __typename
      }
      squad {
        id
        sessionId
        name
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      routines {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listStages = /* GraphQL */ `
  query ListStages(
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        rotationId
        status
        apparatus
        squadId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStages = /* GraphQL */ `
  query SyncStages(
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        rotationId
        status
        apparatus
        squadId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStageStream = /* GraphQL */ `
  query GetStageStream($id: ID!) {
    getStageStream(id: $id) {
      id
      sessionId
      rotationId
      stageId
      streamId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      stage {
        id
        sessionId
        rotationId
        status
        apparatus
        squadId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      owner
      stream {
        id
        streamId
        ingestURL
        outputURL
        tempOutputURL
        vodURL
        recordingURL
        recordingId
        sessionKey
        sessionId
        index
        meta
        stats
        error
        status
        vodMeta
        recordingMeta
        createdAt
        updatedAt
        owner
        type
        title
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      __typename
    }
  }
`;
export const listStageStreams = /* GraphQL */ `
  query ListStageStreams(
    $filter: ModelStageStreamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageStreams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        rotationId
        stageId
        streamId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStageStreams = /* GraphQL */ `
  query SyncStageStreams(
    $filter: ModelStageStreamFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStageStreams(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        rotationId
        stageId
        streamId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStageJudge = /* GraphQL */ `
  query GetStageJudge($id: ID!) {
    getStageJudge(id: $id) {
      id
      sessionId
      rotationId
      stageId
      sessionJudgeAssignmentId
      scoreTypes
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      stage {
        id
        sessionId
        rotationId
        status
        apparatus
        squadId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      owner
      sessionJudgeAssignment {
        id
        sessionId
        judgeId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listStageJudges = /* GraphQL */ `
  query ListStageJudges(
    $filter: ModelStageJudgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageJudges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        rotationId
        stageId
        sessionJudgeAssignmentId
        scoreTypes
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStageJudges = /* GraphQL */ `
  query SyncStageJudges(
    $filter: ModelStageJudgeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStageJudges(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        rotationId
        stageId
        sessionJudgeAssignmentId
        scoreTypes
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSquad = /* GraphQL */ `
  query GetSquad($id: ID!) {
    getSquad(id: $id) {
      id
      sessionId
      name
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      rosters {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listSquads = /* GraphQL */ `
  query ListSquads(
    $filter: ModelSquadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSquads(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        name
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSquads = /* GraphQL */ `
  query SyncSquads(
    $filter: ModelSquadFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSquads(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        name
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLineupMember = /* GraphQL */ `
  query GetLineupMember($id: ID!) {
    getLineupMember(id: $id) {
      id
      sessionId
      sessionRosterId
      athleteContextId
      apparatus
      position
      routineId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
      athleteContext {
        id
        athleteId
        level
        division
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      sessionRoster {
        id
        rosterId
        sessionId
        squadId
        squadStartPosition
        lineupId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      routine {
        id
        sessionId
        rotationId
        stageId
        athleteId
        athleteContextId
        apparatus
        order
        rotation
        lineupId
        status
        score
        isEdited
        createdAt
        startedAt
        completedAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listLineupMembers = /* GraphQL */ `
  query ListLineupMembers(
    $filter: ModelLineupMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLineupMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        sessionRosterId
        athleteContextId
        apparatus
        position
        routineId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncLineupMembers = /* GraphQL */ `
  query SyncLineupMembers(
    $filter: ModelLineupMemberFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLineupMembers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        sessionRosterId
        athleteContextId
        apparatus
        position
        routineId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getAthleteContext = /* GraphQL */ `
  query GetAthleteContext($id: ID!) {
    getAthleteContext(id: $id) {
      id
      athleteId
      level
      division
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
      athlete {
        id
        teamAffiliations
        userId
        gender
        name
        firstName
        lastName
        birthday
        homeTown
        country
        profileImg
        altNames
        slug
        type
        colors
        status
        rtnId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      rosters {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listAthleteContexts = /* GraphQL */ `
  query ListAthleteContexts(
    $filter: ModelAthleteContextFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAthleteContexts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        athleteId
        level
        division
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncAthleteContexts = /* GraphQL */ `
  query SyncAthleteContexts(
    $filter: ModelAthleteContextFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAthleteContexts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        athleteId
        level
        division
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getRosterLink = /* GraphQL */ `
  query GetRosterLink($id: ID!) {
    getRosterLink(id: $id) {
      id
      rosterId
      athleteId
      classYear
      position
      active
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
      athlete {
        id
        teamAffiliations
        userId
        gender
        name
        firstName
        lastName
        birthday
        homeTown
        country
        profileImg
        altNames
        slug
        type
        colors
        status
        rtnId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      roster {
        id
        teamId
        activeDate
        archived
        title
        updatedAt
        createdAt
        default
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listRosterLinks = /* GraphQL */ `
  query ListRosterLinks(
    $filter: ModelRosterLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRosterLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        rosterId
        athleteId
        classYear
        position
        active
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRosterLinks = /* GraphQL */ `
  query SyncRosterLinks(
    $filter: ModelRosterLinkFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRosterLinks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        rosterId
        athleteId
        classYear
        position
        active
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getAthlete = /* GraphQL */ `
  query GetAthlete($id: ID!) {
    getAthlete(id: $id) {
      id
      teamAffiliations
      userId
      gender
      name
      firstName
      lastName
      birthday
      homeTown
      country
      profileImg
      altNames
      slug
      type
      colors
      status
      rtnId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      contexts {
        nextToken
        startedAt
        __typename
      }
      rosters {
        nextToken
        startedAt
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listAthletes = /* GraphQL */ `
  query ListAthletes(
    $filter: ModelAthleteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAthletes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        teamAffiliations
        userId
        gender
        name
        firstName
        lastName
        birthday
        homeTown
        country
        profileImg
        altNames
        slug
        type
        colors
        status
        rtnId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const searchAthletes = /* GraphQL */ `
  query SearchAthletes(
    $filter: SearchableAthleteFilterInput
    $sort: SearchableAthleteSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchAthletes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        teamAffiliations
        userId
        gender
        name
        firstName
        lastName
        birthday
        homeTown
        country
        profileImg
        altNames
        slug
        type
        colors
        status
        rtnId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const syncAthletes = /* GraphQL */ `
  query SyncAthletes(
    $filter: ModelAthleteFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAthletes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teamAffiliations
        userId
        gender
        name
        firstName
        lastName
        birthday
        homeTown
        country
        profileImg
        altNames
        slug
        type
        colors
        status
        rtnId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeamCoach = /* GraphQL */ `
  query GetTeamCoach($id: ID!) {
    getTeamCoach(id: $id) {
      id
      teamId
      userId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      user {
        id
        email
        status
        athleteId
        judgeType
        judgeTypeProxy
        createdAt
        updatedAt
        name
        firstName
        lastName
        location
        handle
        colors
        profileImg
        googleId
        facebookId
        appleId
        cognitoId
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      team {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listTeamCoachs = /* GraphQL */ `
  query ListTeamCoachs(
    $filter: ModelTeamCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeamCoachs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        teamId
        userId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeamCoaches = /* GraphQL */ `
  query SyncTeamCoaches(
    $filter: ModelTeamCoachFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeamCoaches(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teamId
        userId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getJudge = /* GraphQL */ `
  query GetJudge($id: ID!) {
    getJudge(id: $id) {
      id
      name
      womensBrevet
      womensNational
      womensLevel10
      mensBrevet
      mensOptional
      mensCompulsory
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
      sessionAssignments {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listJudges = /* GraphQL */ `
  query ListJudges(
    $filter: ModelJudgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJudges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        womensBrevet
        womensNational
        womensLevel10
        mensBrevet
        mensOptional
        mensCompulsory
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const searchJudges = /* GraphQL */ `
  query SearchJudges(
    $filter: SearchableJudgeFilterInput
    $sort: SearchableJudgeSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchJudges(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        womensBrevet
        womensNational
        womensLevel10
        mensBrevet
        mensOptional
        mensCompulsory
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const syncJudges = /* GraphQL */ `
  query SyncJudges(
    $filter: ModelJudgeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncJudges(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        womensBrevet
        womensNational
        womensLevel10
        mensBrevet
        mensOptional
        mensCompulsory
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSessionJudgeAssignment = /* GraphQL */ `
  query GetSessionJudgeAssignment($id: ID!) {
    getSessionJudgeAssignment(id: $id) {
      id
      sessionId
      judgeId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      stages {
        nextToken
        startedAt
        __typename
      }
      judge {
        id
        name
        womensBrevet
        womensNational
        womensLevel10
        mensBrevet
        mensOptional
        mensCompulsory
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listSessionJudgeAssignments = /* GraphQL */ `
  query ListSessionJudgeAssignments(
    $filter: ModelSessionJudgeAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessionJudgeAssignments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionId
        judgeId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSessionJudgeAssignments = /* GraphQL */ `
  query SyncSessionJudgeAssignments(
    $filter: ModelSessionJudgeAssignmentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSessionJudgeAssignments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        judgeId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSessionJudge = /* GraphQL */ `
  query GetSessionJudge($id: ID!) {
    getSessionJudge(id: $id) {
      id
      sessionId
      userId
      status
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      user {
        id
        email
        status
        athleteId
        judgeType
        judgeTypeProxy
        createdAt
        updatedAt
        name
        firstName
        lastName
        location
        handle
        colors
        profileImg
        googleId
        facebookId
        appleId
        cognitoId
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listSessionJudges = /* GraphQL */ `
  query ListSessionJudges(
    $filter: ModelSessionJudgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessionJudges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        userId
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSessionJudges = /* GraphQL */ `
  query SyncSessionJudges(
    $filter: ModelSessionJudgeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSessionJudges(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        userId
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeam = /* GraphQL */ `
  query GetTeam($id: ID!) {
    getTeam(id: $id) {
      id
      name
      slug
      location
      altNames
      gender
      colors
      logos
      type
      status
      rtnId
      triCode
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      coaches {
        nextToken
        startedAt
        __typename
      }
      owner
      sessions {
        nextToken
        startedAt
        __typename
      }
      leagues {
        nextToken
        startedAt
        __typename
      }
      rosters {
        nextToken
        startedAt
        __typename
      }
      lineups {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listTeams = /* GraphQL */ `
  query ListTeams(
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const searchTeams = /* GraphQL */ `
  query SearchTeams(
    $filter: SearchableTeamFilterInput
    $sort: SearchableTeamSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchTeams(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const syncTeams = /* GraphQL */ `
  query SyncTeams(
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeams(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSessionTeam = /* GraphQL */ `
  query GetSessionTeam($id: ID!) {
    getSessionTeam(id: $id) {
      id
      sessionId
      teamId
      order
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      team {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listSessionTeams = /* GraphQL */ `
  query ListSessionTeams(
    $filter: ModelSessionTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessionTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        teamId
        order
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const SessionTeamsBySessionByOrder = /* GraphQL */ `
  query SessionTeamsBySessionByOrder(
    $sessionId: ID
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSessionTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SessionTeamsBySessionByOrder(
      sessionId: $sessionId
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionId
        teamId
        order
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const SessionTeamsByTeamByOrder = /* GraphQL */ `
  query SessionTeamsByTeamByOrder(
    $teamId: ID
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSessionTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SessionTeamsByTeamByOrder(
      teamId: $teamId
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionId
        teamId
        order
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSessionTeams = /* GraphQL */ `
  query SyncSessionTeams(
    $filter: ModelSessionTeamFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSessionTeams(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        teamId
        order
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLeague = /* GraphQL */ `
  query GetLeague($id: ID!) {
    getLeague(id: $id) {
      id
      name
      altNames
      slug
      colors
      logos
      type
      gender
      createdAt
      updatedAt
      status
      _version
      _deleted
      _lastChangedAt
      owner
      teams {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listLeagues = /* GraphQL */ `
  query ListLeagues(
    $filter: ModelLeagueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeagues(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        altNames
        slug
        colors
        logos
        type
        gender
        createdAt
        updatedAt
        status
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const searchLeagues = /* GraphQL */ `
  query SearchLeagues(
    $filter: SearchableLeagueFilterInput
    $sort: SearchableLeagueSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchLeagues(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        altNames
        slug
        colors
        logos
        type
        gender
        createdAt
        updatedAt
        status
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const syncLeagues = /* GraphQL */ `
  query SyncLeagues(
    $filter: ModelLeagueFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLeagues(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        altNames
        slug
        colors
        logos
        type
        gender
        createdAt
        updatedAt
        status
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLeagueTeam = /* GraphQL */ `
  query GetLeagueTeam($id: ID!) {
    getLeagueTeam(id: $id) {
      id
      leagueId
      teamId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      team {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      league {
        id
        name
        altNames
        slug
        colors
        logos
        type
        gender
        createdAt
        updatedAt
        status
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listLeagueTeams = /* GraphQL */ `
  query ListLeagueTeams(
    $filter: ModelLeagueTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeagueTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        leagueId
        teamId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncLeagueTeams = /* GraphQL */ `
  query SyncLeagueTeams(
    $filter: ModelLeagueTeamFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLeagueTeams(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        leagueId
        teamId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getScore = /* GraphQL */ `
  query GetScore($id: ID!) {
    getScore(id: $id) {
      id
      routineId
      sessionId
      createdAt
      value
      type
      userId
      locked
      _version
      _deleted
      _lastChangedAt
      updatedAt
      owner
      routine {
        id
        sessionId
        rotationId
        stageId
        athleteId
        athleteContextId
        apparatus
        order
        rotation
        lineupId
        status
        score
        isEdited
        createdAt
        startedAt
        completedAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listScores = /* GraphQL */ `
  query ListScores(
    $filter: ModelScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listScores(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        routineId
        sessionId
        createdAt
        value
        type
        userId
        locked
        _version
        _deleted
        _lastChangedAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncScores = /* GraphQL */ `
  query SyncScores(
    $filter: ModelScoreFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncScores(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        routineId
        sessionId
        createdAt
        value
        type
        userId
        locked
        _version
        _deleted
        _lastChangedAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPenalty = /* GraphQL */ `
  query GetPenalty($id: ID!) {
    getPenalty(id: $id) {
      id
      teamId
      lineupId
      sessionId
      createdAt
      rotationId
      value
      type
      userId
      locked
      notes
      valueType
      status
      _version
      _deleted
      _lastChangedAt
      updatedAt
      owner
      lineup {
        id
        teamId
        sessionId
        eventId
        order
        title
        updatedAt
        createdAt
        colors
        logos
        lineupData
        sessionTeamId
        forceTitle
        individuals
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listPenaltys = /* GraphQL */ `
  query ListPenaltys(
    $filter: ModelPenaltyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPenaltys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        teamId
        lineupId
        sessionId
        createdAt
        rotationId
        value
        type
        userId
        locked
        notes
        valueType
        status
        _version
        _deleted
        _lastChangedAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPenalties = /* GraphQL */ `
  query SyncPenalties(
    $filter: ModelPenaltyFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPenalties(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teamId
        lineupId
        sessionId
        createdAt
        rotationId
        value
        type
        userId
        locked
        notes
        valueType
        status
        _version
        _deleted
        _lastChangedAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getRoster = /* GraphQL */ `
  query GetRoster($id: ID!) {
    getRoster(id: $id) {
      id
      teamId
      activeDate
      archived
      title
      updatedAt
      createdAt
      default
      _version
      _deleted
      _lastChangedAt
      athletes {
        nextToken
        startedAt
        __typename
      }
      team {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      owner
      athleteContexts {
        nextToken
        startedAt
        __typename
      }
      sessions {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listRosters = /* GraphQL */ `
  query ListRosters(
    $filter: ModelRosterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRosters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        teamId
        activeDate
        archived
        title
        updatedAt
        createdAt
        default
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRosters = /* GraphQL */ `
  query SyncRosters(
    $filter: ModelRosterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRosters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teamId
        activeDate
        archived
        title
        updatedAt
        createdAt
        default
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getRosterAthleteContext = /* GraphQL */ `
  query GetRosterAthleteContext($id: ID!) {
    getRosterAthleteContext(id: $id) {
      id
      rosterId
      athleteContextId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      athleteContext {
        id
        athleteId
        level
        division
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      roster {
        id
        teamId
        activeDate
        archived
        title
        updatedAt
        createdAt
        default
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listRosterAthleteContexts = /* GraphQL */ `
  query ListRosterAthleteContexts(
    $filter: ModelRosterAthleteContextFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRosterAthleteContexts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        rosterId
        athleteContextId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRosterAthleteContexts = /* GraphQL */ `
  query SyncRosterAthleteContexts(
    $filter: ModelRosterAthleteContextFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRosterAthleteContexts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        rosterId
        athleteContextId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSessionRoster = /* GraphQL */ `
  query GetSessionRoster($id: ID!) {
    getSessionRoster(id: $id) {
      id
      rosterId
      sessionId
      squadId
      squadStartPosition
      lineupId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      squad {
        id
        sessionId
        name
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      lineup {
        nextToken
        startedAt
        __typename
      }
      roster {
        id
        teamId
        activeDate
        archived
        title
        updatedAt
        createdAt
        default
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listSessionRosters = /* GraphQL */ `
  query ListSessionRosters(
    $filter: ModelSessionRosterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessionRosters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        rosterId
        sessionId
        squadId
        squadStartPosition
        lineupId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSessionRosters = /* GraphQL */ `
  query SyncSessionRosters(
    $filter: ModelSessionRosterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSessionRosters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        rosterId
        sessionId
        squadId
        squadStartPosition
        lineupId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLineup = /* GraphQL */ `
  query GetLineup($id: ID!) {
    getLineup(id: $id) {
      id
      teamId
      sessionId
      eventId
      order
      title
      updatedAt
      createdAt
      colors
      logos
      lineupData
      sessionTeamId
      forceTitle
      individuals
      _version
      _deleted
      _lastChangedAt
      team {
        id
        name
        slug
        location
        altNames
        gender
        colors
        logos
        type
        status
        rtnId
        triCode
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      penalties {
        nextToken
        startedAt
        __typename
      }
      owner
      routines {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listLineups = /* GraphQL */ `
  query ListLineups(
    $filter: ModelLineupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLineups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        teamId
        sessionId
        eventId
        order
        title
        updatedAt
        createdAt
        colors
        logos
        lineupData
        sessionTeamId
        forceTitle
        individuals
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncLineups = /* GraphQL */ `
  query SyncLineups(
    $filter: ModelLineupFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLineups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teamId
        sessionId
        eventId
        order
        title
        updatedAt
        createdAt
        colors
        logos
        lineupData
        sessionTeamId
        forceTitle
        individuals
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStream = /* GraphQL */ `
  query GetStream($id: ID!) {
    getStream(id: $id) {
      id
      streamId
      ingestURL
      outputURL
      tempOutputURL
      vodURL
      recordingURL
      recordingId
      sessionKey
      sessionId
      index
      meta
      stats
      error
      status
      vodMeta
      recordingMeta
      createdAt
      updatedAt
      owner
      type
      title
      _version
      _deleted
      _lastChangedAt
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      stages {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listStreams = /* GraphQL */ `
  query ListStreams(
    $filter: ModelStreamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStreams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        streamId
        ingestURL
        outputURL
        tempOutputURL
        vodURL
        recordingURL
        recordingId
        sessionKey
        sessionId
        index
        meta
        stats
        error
        status
        vodMeta
        recordingMeta
        createdAt
        updatedAt
        owner
        type
        title
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStreams = /* GraphQL */ `
  query SyncStreams(
    $filter: ModelStreamFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStreams(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        streamId
        ingestURL
        outputURL
        tempOutputURL
        vodURL
        recordingURL
        recordingId
        sessionKey
        sessionId
        index
        meta
        stats
        error
        status
        vodMeta
        recordingMeta
        createdAt
        updatedAt
        owner
        type
        title
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getOverlay = /* GraphQL */ `
  query GetOverlay($id: ID!) {
    getOverlay(id: $id) {
      id
      routineId
      clipId
      streamId
      sessionKey
      sessionId
      command
      delay
      displayAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      session {
        id
        sessionKey
        name
        type
        gender
        judging
        judgingRequired
        competition
        apparatus
        access
        startAt
        endAt
        status
        teamScoring
        alternating
        judgePanel
        createdAt
        updatedAt
        admins
        producers
        coaches
        judges
        producer
        featureFlags
        rtnId
        hostId
        hostType
        location
        attendance
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      stream {
        id
        streamId
        ingestURL
        outputURL
        tempOutputURL
        vodURL
        recordingURL
        recordingId
        sessionKey
        sessionId
        index
        meta
        stats
        error
        status
        vodMeta
        recordingMeta
        createdAt
        updatedAt
        owner
        type
        title
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listOverlays = /* GraphQL */ `
  query ListOverlays(
    $filter: ModelOverlayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOverlays(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        routineId
        clipId
        streamId
        sessionKey
        sessionId
        command
        delay
        displayAt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const StreamOverlays = /* GraphQL */ `
  query StreamOverlays(
    $streamId: ID
    $displayAtCreatedAt: ModelOverlayStreamOverlaysCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOverlayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    StreamOverlays(
      streamId: $streamId
      displayAtCreatedAt: $displayAtCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        routineId
        clipId
        streamId
        sessionKey
        sessionId
        command
        delay
        displayAt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const SessionOverlays = /* GraphQL */ `
  query SessionOverlays(
    $sessionId: ID
    $displayAtCreatedAt: ModelOverlaySessionOverlaysCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOverlayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SessionOverlays(
      sessionId: $sessionId
      displayAtCreatedAt: $displayAtCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        routineId
        clipId
        streamId
        sessionKey
        sessionId
        command
        delay
        displayAt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncOverlays = /* GraphQL */ `
  query SyncOverlays(
    $filter: ModelOverlayFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncOverlays(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        routineId
        clipId
        streamId
        sessionKey
        sessionId
        command
        delay
        displayAt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getClip = /* GraphQL */ `
  query GetClip($id: ID!) {
    getClip(id: $id) {
      id
      routineId
      sessionId
      streamId
      seekStartSeconds
      seekEndSeconds
      startTime
      endTime
      pgmStartTime
      pgmEndTime
      duration
      fileName
      originURL
      owner
      type
      status
      location
      resolution
      fps
      bitrate
      fileSize
      source
      codecs
      other
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      routine {
        id
        sessionId
        rotationId
        stageId
        athleteId
        athleteContextId
        apparatus
        order
        rotation
        lineupId
        status
        score
        isEdited
        createdAt
        startedAt
        completedAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const listClips = /* GraphQL */ `
  query ListClips(
    $filter: ModelClipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClips(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        routineId
        sessionId
        streamId
        seekStartSeconds
        seekEndSeconds
        startTime
        endTime
        pgmStartTime
        pgmEndTime
        duration
        fileName
        originURL
        owner
        type
        status
        location
        resolution
        fps
        bitrate
        fileSize
        source
        codecs
        other
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncClips = /* GraphQL */ `
  query SyncClips(
    $filter: ModelClipFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncClips(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        routineId
        sessionId
        streamId
        seekStartSeconds
        seekEndSeconds
        startTime
        endTime
        pgmStartTime
        pgmEndTime
        duration
        fileName
        originURL
        owner
        type
        status
        location
        resolution
        fps
        bitrate
        fileSize
        source
        codecs
        other
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getRoutine = /* GraphQL */ `
  query GetRoutine($id: ID!) {
    getRoutine(id: $id) {
      id
      sessionId
      rotationId
      stageId
      athleteId
      athleteContextId
      apparatus
      order
      rotation
      lineupId
      status
      score
      isEdited
      createdAt
      startedAt
      completedAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      stage {
        id
        sessionId
        rotationId
        status
        apparatus
        squadId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      athleteContext {
        id
        athleteId
        level
        division
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      athlete {
        id
        teamAffiliations
        userId
        gender
        name
        firstName
        lastName
        birthday
        homeTown
        country
        profileImg
        altNames
        slug
        type
        colors
        status
        rtnId
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      scores {
        nextToken
        startedAt
        __typename
      }
      lineup {
        id
        teamId
        sessionId
        eventId
        order
        title
        updatedAt
        createdAt
        colors
        logos
        lineupData
        sessionTeamId
        forceTitle
        individuals
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      clips {
        nextToken
        startedAt
        __typename
      }
      owner
      inquiries {
        nextToken
        startedAt
        __typename
      }
      __typename
    }
  }
`;
export const listRoutines = /* GraphQL */ `
  query ListRoutines(
    $filter: ModelRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoutines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        rotationId
        stageId
        athleteId
        athleteContextId
        apparatus
        order
        rotation
        lineupId
        status
        score
        isEdited
        createdAt
        startedAt
        completedAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const SessionRoutines = /* GraphQL */ `
  query SessionRoutines(
    $sessionId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SessionRoutines(
      sessionId: $sessionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionId
        rotationId
        stageId
        athleteId
        athleteContextId
        apparatus
        order
        rotation
        lineupId
        status
        score
        isEdited
        createdAt
        startedAt
        completedAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRoutines = /* GraphQL */ `
  query SyncRoutines(
    $filter: ModelRoutineFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRoutines(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        rotationId
        stageId
        athleteId
        athleteContextId
        apparatus
        order
        rotation
        lineupId
        status
        score
        isEdited
        createdAt
        startedAt
        completedAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getInquiry = /* GraphQL */ `
  query GetInquiry($id: ID!) {
    getInquiry(id: $id) {
      id
      sessionId
      routineId
      status
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      routine {
        id
        sessionId
        rotationId
        stageId
        athleteId
        athleteContextId
        apparatus
        order
        rotation
        lineupId
        status
        score
        isEdited
        createdAt
        startedAt
        completedAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      owner
      __typename
    }
  }
`;
export const listInquirys = /* GraphQL */ `
  query ListInquirys(
    $filter: ModelInquiryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInquirys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sessionId
        routineId
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncInquiries = /* GraphQL */ `
  query SyncInquiries(
    $filter: ModelInquiryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncInquiries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        sessionId
        routineId
        status
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSiteSettings = /* GraphQL */ `
  query GetSiteSettings($id: ID!) {
    getSiteSettings(id: $id) {
      id
      settingsType
      currentSeason
      seasonLabel
      homepageData
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSiteSettingss = /* GraphQL */ `
  query ListSiteSettingss(
    $filter: ModelSiteSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSiteSettingss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        settingsType
        currentSeason
        seasonLabel
        homepageData
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSiteSettings = /* GraphQL */ `
  query SyncSiteSettings(
    $filter: ModelSiteSettingsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSiteSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        settingsType
        currentSeason
        seasonLabel
        homepageData
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
